import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Link, useNavigate } from "react-router-dom";

const RemovalKitB = () => {




    return (
        <div>
            <div className="addcart-section section">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-4">
                            <div className="cart-product">
                                <img src="/images/Removal-Kit-B.png" alt="image" />
                            </div>
                        </div>
                        <div className="col-sm-8">
                            <div className="productDetailSec">
                                <h2>Removal Kit B</h2>
                                <p>This removal kit is suitable for most 2-3 bedroom house moves, and is set at a great price for the end consumer. It comprises a mixture of 60 cardboard boxes (both single and double wall) as well as a mixture of the packaging materials required during a move. The exact items the kit comprises are listed below:</p>
                                <h3>£343</h3>
                                <div>
                                    <p style={{ fontWeight: 'bold' }}>Size:</p>
                                    <p>20 x Small Double Wall Boxes – 458x305x304mm</p>
                                    <p>20 x Medium Double Wall Boxes - 458x458x305mm
                                    </p>
                                    <p>20 x Large Double Wall Boxes – 458x458x508mm
                                    </p>
                                    <p>2 x Wardrobe Boxes -  508x458x1220mm
                                    </p>
                                    <p>Full pack kitchen white paper (430x510mm, 10.0 kg per pack)
                                    </p>
                                    <p>1 x Small Bubble Wrap - 500X100mm
                                    </p>
                                    <p>1 x Shrink Wrap -400mmx250m
                                    </p>
                                    <p>6 x Brown Packing Tapes
                                    </p>
                                    <p>1 x Fragile Tape
                                    </p>
                                    <p>10 x Heavy-Duty Bin Bags
                                    </p>
                                    <p>1 x Marker Pen
                                    </p>
                                </div>


                                {/* <form> */}
                                <div className="row">

                                    {/* <div className="col-sm-6 mt-4">
                                        <label>

                                        </label>
                                        <select
                                            class="form-select"
                                            aria-label="Default select example">
                                            <option>No</option>
                                            <option>Standard +£</option>

                                            <option value="55"> Personalised (+£55) </option>

                                        </select>
                                    </div> */}



                                    {/* <div className="col-sm-6 mt-4">
                          <label>The Value of Your Dress</label>
                          <div className="inputboxWithIcon">
                            <input
                              type="number"
                              name=""
                              class="form-control"
                              id=""
                              // placeholder="+£"
                            />
                            <span>£</span>
                          </div>
                        </div> */}


                                    {/* <div className="col-sm-12 mt-4">
                      <textarea
                        className="form-control"
                        rows={4}
                        placeholder="Type Your Personalisation Below"
                      ></textarea>
                    </div> */}


                                    <div className="col-sm-6 mt-1">

                                        <Link to="/cart">
                                            <button className="btn2 mt-4">Go to cart</button>
                                        </Link>

                                        {/* <button
                                            className="btn2 mt-4"
                                            onClick={() => handleCart()}
                                        >
                                            Add to cart
                                        </button> */}

                                    </div>
                                </div>
                                {/* </form> */}
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default RemovalKitB;
